import React, { useMemo, useState, useEffect } from 'react';
import { Box, Paper } from '@mui/material';
import { getCanopyFrameSelection } from '../utils/canopyFrameSelector';

/**
 * CanopyAnimationPanel
 *
 * Renders exactly one canopy frame for the currently displayed telemetry record.
 * The record itself governs the animation (state, doors, array distance, tilt, etc.).
 */
export default function CanopyAnimationPanel({
  record,
  height = '100%',
  maxImageHeight = 520
}) {
  const selection = useMemo(() => getCanopyFrameSelection(record, { ignoreStale: true }), [record]);

  const [imgSrc, setImgSrc] = useState(selection.src);
  useEffect(() => {
    setImgSrc(selection.src);
  }, [selection.src]);

  return (
    <Paper
      elevation={2}
      sx={{
        p: 1.5,
        height,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >
        <Box
          component="img"
          alt="Canopy frame"
          src={imgSrc}
          loading="eager"
          onError={() => {
            // If unknown frame isn't present, fall back to maintenance.
            if (!imgSrc.includes('/05Status/Maintenance.jpg')) {
              setImgSrc('/canopy-frames/05Status/Maintenance.jpg');
            }
          }}
          sx={{
            width: '100%',
            maxHeight: maxImageHeight,
            objectFit: 'contain',
            borderRadius: 1,
            backgroundColor: 'background.default'
          }}
        />
      </Box>
    </Paper>
  );
}

